import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { UscStoreService } from '../../../services/usc-store/usc-store.service';
import { AuthService } from '../../../services';

@Component({
  selector: 'sn-usc-dashboard-nav',
  templateUrl: './usc-dashboard-nav.component.html',
  styleUrls: ['./usc-dashboard-nav.component.css']
})

export class UscDashboardNavComponent implements OnInit {
    @Input() view: string;

    current_campaign: string = "All";
    currentViewClass: any = {
        view_usc_dashboard_lead_contacted: "nav-item",
        view_usc_dashboard_lead_contacted_leaderboard: "nav-item",
        view_usc_dashboard_scheduled_appts_held: "nav-item",
        view_usc_dashboard_scheduled_appts_held_leaderboard: "nav-item",
        view_usc_classic_dashboards: "nav-item",
    }

    isAdmin: boolean = false;
    isLeader: boolean = false;
    isTelesales: boolean = false;
    isUSCellCorp: boolean = false;
    isStoreMgrOrAssistant: boolean = false;
    isTelesaleManagers: boolean = false;

    constructor(
        public uscStoreService: UscStoreService,
        private authService: AuthService,
        private router: Router,
    ) { }

    ngOnInit() {
        for (var p in this.currentViewClass) {
            this.currentViewClass[p] = "nav-item";
            if (p == this.view) {
                this.currentViewClass[p] = "nav-item active";
            }
        }

        this.authService.currentUser.subscribe(
            user => {
                this.isAdmin = this.uscStoreService.isAdmin();
                this.isLeader = this.uscStoreService.isLeader();
                this.isTelesales = this.uscStoreService.isUSCellTelesales();
                this.isUSCellCorp = this.uscStoreService.isUSCellCorp();
                this.isStoreMgrOrAssistant = this.uscStoreService.isStoreMgrOrAssistant();
                this.isTelesaleManagers = this.uscStoreService.isTelesalesManager();
            }
        )
    }

    navigate(selection) {
        this.uscStoreService.setCurrentView(selection);
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-dashboard-nav/usc-dashboard-nav.component.ts